import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PcceAgentsFieldConfig } from '../../../../shared/models/generated/ziroModels';
import { PcceAgentFieldConfigRequest } from '../../../cisco/pcce-agent-settings/pcce-agent-settings.component';

@Injectable()
export class PcceAgentFieldConfigResource {
  private http = inject(HttpClient);

  getFieldConfigs(req: PcceAgentFieldConfigRequest): Observable<PcceAgentsFieldConfig> {
    return this.http.get<PcceAgentsFieldConfig>(
      `/services/cisco/field-configs/pcce-agents?pcce-server-id=${req.pcceServerId}&department=${
        req.department
      }&username=${encodeURIComponent(req.username)}`,
    );
  }
}
